var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.workers),function(wk){return _c('v-flex',{key:wk.description,attrs:{"md12":""}},[_c('worker-detail',{attrs:{"worker_detail":wk,"token":_vm.getConsumer(_vm.w_type).token,"w_type":_vm.w_type}})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }